module.exports = function(app) {
    'use strict';
    app.service('changePcpSuccess', ['services', '$filter', 'sessionData', function(services, $filter, sessionData) {

            this.getSuccessMessage = function (ubk, reasonCode) {
                var theMsg;

                // var twoReasonCodes = ['22', '25'];
                // // we have to display a different success message for these two reason codes.
                // //     one is, No Initial PCP Selection
                // var itsOneOfTheReasonCodes = (twoReasonCodes.indexOf(reasonCode) > -1) ? true : false;
                    switch (ubk) {
                        case '6008':
                            theMsg = 'You have successfully changed your PCP. You will receive your ID card in 5-10 business days. If additional assistance is needed, please contact Customer Service.';
                            break;
                        case '6009':
                            // AHNJ
                            theMsg = 'You have successfully changed your PCP. You will receive your ID card in 5-10 business days. If additional assistance is needed, please contact Customer Service.';
                            break;
                        default:
                            // All others
                            theMsg = 'The PCP was successfully updated.';
                            break;
                    }
                return theMsg;

            } } ] ); }
